import { keyBy, map } from 'lodash';
export const DRAFT = {
    value: 'DRAFT',
    name: 'Draft',
};
export const SENDING = {
    value: 'SENDING',
    name: 'Sending',
};
export const SENT = {
    value: 'SENT',
    name: 'Sent',
};
export const SCHEDULED = {
    value: 'SCHEDULED',
    name: 'Scheduled',
};
export const QUEUED = {
    value: 'QUEUED',
    name: 'Queued',
};
export const STOPPED = {
    value: 'STOPPED',
    name: 'Stopped',
};
export const ERROR = {
    value: 'ERROR',
    name: 'Error',
};
export const DELETED = {
    value: 'DELETED',
    name: 'Deleted',
};
export const CANCELLED = {
    value: 'CANCELLED',
    name: 'Cancelled',
};
//email
export const BasicSelector = [
    [DRAFT, SENDING, SENT],
    [SCHEDULED, QUEUED, STOPPED, CANCELLED, ERROR],
];
export const Basic = [
    DRAFT,
    SENDING,
    SENT,
    SCHEDULED,
    QUEUED,
    STOPPED,
    ERROR,
    CANCELLED,
];
export const DefaultSelector = map(Basic, ({ value }) => value);
//notification
export const BasicNotificationSelector = [
    [DRAFT, SENDING, SENT],
    [SCHEDULED, QUEUED, DELETED, ERROR],
];
export const NotificationBasic = [
    DRAFT,
    SENDING,
    SENT,
    SCHEDULED,
    QUEUED,
    ERROR,
    DELETED,
];
export const DefaultNotificationSelector = map(NotificationBasic, ({ value }) => value);
export const BasicByValue = keyBy([...Basic, DELETED], 'value');
export const ColorMap = {
    DRAFT: '#939393',
    SENDING: '#ff9800',
    SENT: '#4caf50',
    SCHEDULED: '#2196f3',
    QUEUED: '#939393',
    STOPPED: '#333333',
    ERROR: '#f54336',
    DELETED: '#737F80',
    CANCELLED: '#333333',
};
export default {
    DefaultSelector,
    BasicSelector,
    Basic,
    DefaultNotificationSelector,
    BasicNotificationSelector,
    NotificationBasic,
    BasicByValue,
    DRAFT,
    SENDING,
    SENT,
    SCHEDULED,
    QUEUED,
    STOPPED,
    ERROR,
    CANCELLED,
};
